import ServiceProducts from '../../services/Products';
import Helper from '../../helpers/Helper';
import { scrollIntoElement } from '../scroll/actions';
import { GET_LIMIT, SCROLL_TO_TYPE, CRUD_TYPES, HTTP_STATUS_CODE } from '../../helpers/constants';

export const LOADING_PRODUCTS = 'LOADING_PRODUCTS';
export function loadingProducts(loading = true) {
  return {
    type: LOADING_PRODUCTS,
    payload: loading,
  };
}

export const FINISH_LOADING_PRODUCTS = 'FINISH_LOADING_PRODUCTS';
export const finishLoadingProducts = () => ({
  type: FINISH_LOADING_PRODUCTS,
});

export const RECEIVE_PRODUCTS = 'RECEIVE_PRODUCTS';
export function getProducts(categories, exportProducts = false) {
  return {
    type: RECEIVE_PRODUCTS,
    payload: categories,
    exportProducts,
  };
}

export const FINISH_RECEIVE_BY_STATUS = 'FINISH_RECEIVE_BY_STATUS';
export function finishReceiveByStatus() {
  return {
    type: FINISH_RECEIVE_BY_STATUS,
  };
}

export const LOADING_SUBMIT_PRODUCT = 'LOADING_SUBMIT_PRODUCT';
export const loadingSubmitProduct = () => ({
  type: LOADING_SUBMIT_PRODUCT,
});

export const SUBMIT_PRODUCT_SUCCESS = 'SUBMIT_PRODUCT_SUCCESS';
export const saveProductSuccess = product => ({
  type: SUBMIT_PRODUCT_SUCCESS,
  product,
});

export const FINISH_SUBMIT_PRODUCT = 'FINISH_SUBMIT_PRODUCT';
export const finishSubmitProduct = () => ({
  type: FINISH_SUBMIT_PRODUCT,
});

export const PRODUCT_REQUEST_ERROR = 'PRODUCT_REQUEST_ERROR';
export const errorProduct = error => ({
  type: PRODUCT_REQUEST_ERROR,
  error,
});

export const LOADING_PRODUCT = 'LOADING_PRODUCT';
export const loadingProduct = () => ({
  type: LOADING_PRODUCT,
});

export const RECEIVE_PRODUCT_SUCCESS = 'RECEIVE_PRODUCT_SUCCESS';
export const receiveProductSuccess = () => ({
  type: RECEIVE_PRODUCT_SUCCESS,
});

export const ERROR_LOADING_PRODUCTS = 'ERROR_LOADING_PRODUCTS';
export function errorLoadingProducts(error) {
  return {
    type: ERROR_LOADING_PRODUCTS,
    payload: error,
  };
}

export const SHOW_PRODUCT_MODAL = 'SHOW_PRODUCT_MODAL';
export function showModalProduct(type, data) {
  return {
    type: SHOW_PRODUCT_MODAL,
    modalType: type,
    data,
  };
}

export const TOGGLE_PRODUCTS_LIST_PRODUCT = 'TOGGLE_PRODUCTS_LIST_PRODUCT';
export function toggleListProductItem(categoryId, productId) {
  return dispatch => {
    dispatch({
      type: TOGGLE_PRODUCTS_LIST_PRODUCT,
      categoryId,
      productId,
    });

    dispatch(updateProductsCheckedQtty());
  };
}

export const UPDATE_PRODUCTS_CHECKED_QTTY = 'UPDATE_PRODUCTS_CHECKED_QTTY';
export const updateProductsCheckedQtty = () => ({
  type: UPDATE_PRODUCTS_CHECKED_QTTY,
});

export const TOGGLE_PRODUCTS_LIST_CATEGORY = 'TOGGLE_PRODUCTS_LIST_CATEGORY';
export function toggleListCategoryItem(categoryId) {
  return dispatch => {
    dispatch({
      type: TOGGLE_PRODUCTS_LIST_CATEGORY,
      categoryId,
    });

    dispatch(updateProductsCheckedQtty());
  };
}

export const TOGGLE_ALL_PRODUCTS = 'TOGGLE_ALL_PRODUCTS';
export function toggleAllProducts() {
  return dispatch => {
    dispatch({
      type: TOGGLE_ALL_PRODUCTS,
    });

    dispatch(updateProductsCheckedQtty());
  };
}

export const CLOSE_PRODUCT_MODAL = 'CLOSE_PRODUCT_MODAL';
export function closeProductModal() {
  return {
    type: CLOSE_PRODUCT_MODAL,
  };
}

export const DELETE_PRODUCTS_FROM_LIST = 'DELETE_PRODUCTS_FROM_LIST';
export const deleteProductsFromList = data => ({
  type: DELETE_PRODUCTS_FROM_LIST,
  data,
});

export const UPDATE_PRODUCT_STATUS_SUCCESS = 'UPDATE_PRODUCT_STATUS_SUCCESS';
export const updateProductStatusSuccess = (productId, categoryId) => ({
  type: UPDATE_PRODUCT_STATUS_SUCCESS,
  productId,
  categoryId,
});

export function getCategoriesByStatus(status) {
  return async dispatch => {
    dispatch(loadingProducts());
    try {
      const response = await new ServiceProducts().getAllByStatus(status);
      if (!response.data) {
        dispatch(getProducts([]));
      } else {
        dispatch(getProducts(Helper.formatProducts(response.data)));
      }
    } catch (error) {
      dispatch(errorLoadingProducts(error));
      console.error('error in getCategoriesByStatus', error);
    }
  };
}

export function saveProduct(data) {
  return async dispatch => {
    submitProduct(null, data, dispatch, CRUD_TYPES.SAVE);
  };
}

async function submitProduct(id, data, dispatch, type) {
  dispatch(loadingSubmitProduct());
  try {
    let response = null;
    const service = new ServiceProducts();
    if (type === CRUD_TYPES.EDIT) {
      response = await service.put(id, data);
      delete data.categories;
      dispatch(
        scrollIntoElement(Helper.formatItemToScrollInto(response.data, SCROLL_TO_TYPE.product))
      );
    } else if (type === CRUD_TYPES.SAVE) {
      response = await service.save(data);
      dispatch(
        scrollIntoElement(Helper.formatItemToScrollInto(response.data, SCROLL_TO_TYPE.product))
      );
    } else if (type === CRUD_TYPES.DELETE) {
      response = await service.delete(data);
    } else if (type === CRUD_TYPES.SORT_ORDER) {
      response = await service.sortOrder(data);
    }
    if (!response) {
      throw new Error(`Erro ao submeter produto, tente novamente mais tarde`);
    }
    dispatch(saveProductSuccess(CRUD_TYPES.EDIT ? data : null));
  } catch (err) {
    dispatch(
      errorProduct({
        message:
          err.response && err.response.data.message && err.response.data.message.name
            ? err.response.data.message.name
            : err.response.data.code === 422
            ? 'Este produto está vinculado à um produto combo'
            : 'Erro! Verifique os dados e tente novamente',
      })
    );
    console.error('error', err.message);
  }
}

export function editProduct(id, data) {
  return async dispatch => {
    submitProduct(id, data, dispatch, CRUD_TYPES.EDIT);
  };
}

export function deleteProduct(data) {
  return async dispatch => {
    submitProduct(null, data, dispatch, CRUD_TYPES.DELETE);
  };
}

export function updateProductStatus(id, data) {
  return async dispatch => {
    dispatch(loadingSubmitProduct());
    try {
      let response = await new ServiceProducts().patch(id, data);

      if (!response) {
        throw new Error(`Erro ao submeter produto, tente novamente mais tarde`);
      }
      dispatch(updateProductStatusSuccess(id, data.categoryId));
      dispatch(updateProductsCheckedQtty());
    } catch (err) {
      dispatch(
        errorProduct({
          message:
            err.response && err.response.data.message && err.response.data.message.name
              ? err.response.data.message.name
              : 'Erro! Verifique os dados e tente novamente',
        })
      );
      console.error('error', err.message);
    }
  };
}

export function getProductById(id) {
  return async dispatch => {
    dispatch(loadingProduct());
    try {
      const response = await new ServiceProducts().getById(id);
      if (!response) {
        throw new Error('Erro ao buscar produto, tente novamente mais tarde');
      }
      dispatch(receiveProductSuccess());
      return response;
    } catch (error) {}
  };
}

export function getCategoriesWithOffSetAndLimit(offset, limit = GET_LIMIT) {
  return async dispatch => {
    dispatch(loadingProducts());
    try {
      const response = await new ServiceProducts().get(offset, limit);
      if (response.status === HTTP_STATUS_CODE.NO_CONTENT) {
        dispatch(getProducts([]));
      } else {
        dispatch(getProducts(Helper.formatProducts(response.data)));
      }
    } catch (error) {
      dispatch(errorLoadingProducts(error));
      console.error('error in getCategoriesWithOffSetAndLimit', error);
    }
  };
}

export function sortOrderProduct(data) {
  return async dispatch => {
    submitProduct(null, data, dispatch, CRUD_TYPES.SORT_ORDER);
  };
}

export const ORDER_PRODUCT_ITEM = 'ORDER_PRODUCT_ITEM';
export const orderProductItem = (categoryId, currPos, newPos) => ({
  type: ORDER_PRODUCT_ITEM,
  categoryId,
  currPos,
  newPos,
});

export const ORDER_CATEGORY_ITEM = 'ORDER_CATEGORY_ITEM';
export const orderCategoryItem = (currPos, newPos) => ({
  type: ORDER_CATEGORY_ITEM,
  currPos,
  newPos,
});

export const COLLAPSE_CATEGORY = 'COLLAPSE_CATEGORY';
export const collapseCategory = id => ({
  type: COLLAPSE_CATEGORY,
  id,
});

export const SET_COLLAPSE_ALL_CATEGORIES = 'SET_COLLAPSE_ALL_CATEGORIES';
export const setCollapseAllCategories = collapse => ({
  type: SET_COLLAPSE_ALL_CATEGORIES,
  payload: collapse,
});

export const INSERT_NEW_CATEGORY_IN_PRODUCTS_LIST = 'INSERT_NEW_CATEGORY_IN_PRODUCTS_LIST';
export const insertCategoryInProductsList = category => ({
  type: INSERT_NEW_CATEGORY_IN_PRODUCTS_LIST,
  category,
});

export const UPDATE_PRODUCT_CATEGORY_NAME = 'UPDATE_PRODUCT_CATEGORY_NAME';
export const updateProductCategoryName = (idCategory, name) => ({
  type: UPDATE_PRODUCT_CATEGORY_NAME,
  idCategory,
  name,
});



// WEBPACK FOOTER //
// ./src/store/products/actions.js